'use client';

import { useEffect } from 'react';

export interface UseHashScrollOnMountOptions {
  onExpand: () => void;
  hashKey: string;
}

export function useHashScrollOnMount({ onExpand, hashKey }: UseHashScrollOnMountOptions) {
  useEffect(() => {
    if (window.location.hash === `#${hashKey}`) {
      onExpand();

      window.scrollTo(0, 0);

      setTimeout(() => {
        const element = document.getElementById(hashKey);
        if (element) {
          element.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
      }, 10);
    }
  }, [onExpand]);
}
